import { render } from "./note-form.vue?vue&type=template&id=23a66672"
import script from "./note-form.vue?vue&type=script&lang=js"
export * from "./note-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__